import { convertDate } from './helpers';

import { APIROOT } from './configs';

// -- REGIONS FUNCTIONS START -- //
// let newTab;
// const regionsTable = () => {
//   const dataPack = (data) => {
//     const regions = data.map((region) => region.name);
//     const table = [
//       'period',
//       ...regions.sort((a, b) => (a.field > b.field ? 1 : -1)),
//     ];
//     newTab = table;
//     // return table;
//   };
//   filteredRegions().then((data) => {
//     return dataPack(data.data.value);
//   });
// };

// async function filteredRegions() {
//   let JWT = localStorage.getItem('JWT_Key');
//   let headers = {
//     'content-type': 'application/JSON',
//   };

//   if (JWT) {
//     headers['x-api-key'] = JWT;
//   }

//   let body = {
//     pagereq: {
//       filter: {
//         fullfilter: [
//           {
//             field: 'field',
//             search: 'CUS_REGIONS',
//             strict: true,
//           },
//         ],
//       },
//     },
//   };
//   const request = new Request(`${APIROOT}/api/r2_constants`, {
//     method: 'POST',
//     headers: headers,
//     body: JSON.stringify(body),
//   });

//   const response = await fetch(request);

//   const data = response.json();
//   return data;
// }
// regionsTable();
// -- REGIONS FUNCTIONS END -- //

class ExportToCsv {
  schemas = [
    {
      name: 'customer_list',
      endpoint: '/r2_customers',
      filename: 'Customer_List',
      fields: ['name', 'category_name', 'store_tel', 'region_name'],
      headernames: [
        'Customer Name',
        'Category',
        'Store Contact Number',
        'Region',
      ],
    },
    {
      name: 'payroll_report_clock_in',
      endpoint: null,
      filename: 'payroll_clock_in',
      fields: [
        'date',
        'day_of_week',
        'start_time',
        'start_time_override',
        'stop_time',
        'stop_time_override',
        'total_work_hours',
        'total_ot_hours',
        'nt_hours',
        'ot1_hours',
        'ot2_hours',
      ],
      headernames: [
        'Date',
        'Day',
        'Payroll Clock In',
        'Tech Clock In',
        'Payroll Clock Out',
        'Tech Clock Out',
        'Total Work Hours',
        'Total OT',
        'NT Hours',
        'OT1 Hours',
        'OT2 Hours',
      ],
    },
    {
      name: 'payroll_report_tickets',
      endpoint: null,
      filename: 'payroll_tickets',
      fields: [
        'date',
        'day_of_week',
        'ticket_nr',
        'ticket_type',
        'billing_type',
        'store_name',
        'issue_reported',
        'total_labour_time',
        'total_travel_time',
        'total_time',
      ],
      headernames: [
        'Date',
        'Day',
        'Ticket Nr',
        'Ticket Type',
        'Billing',
        'Store Name',
        'Issue Reported',
        'Total Labour Time',
        'Total Travel Time',
        'Total Ticket Time',
      ],
    },
    {
      name: 'repair_bulk_data_report',
      endpoint: null,
      filename: 'repair_bulk_data_report',
      fields: [
        'ticket_type',
        'tech_assigned_name',
        'sub_assigned_name',
        'ticket_nr',
        'date_logged',
        'date_completed',
        'customer_category_name',
        'customer_name',
        'customer_region_name',
        'customer_asset_comp_name',
        'serials_cabinet_types',
        'serials_numbers',
        'serials_descriptions',
        'stock_used',
        'stock_qty',
        'billing_info',
        'invoice_cost_amt',
        'gas_type',
        'gas_qty',
        'customer_rating',
        'labour_hrs_nt',
        'labour_hrs_ot1',
        'labour_hrs_ot2',
        'travel_time_nt',
        'travel_time_ot1',
        'travel_time_ot2',
      ],
      headernames: [
        'Ticket Type',
        'Tech',
        'Sub Contractor',
        'Ticket Number',
        'Date Logged',
        'Date Completed',
        'Category',
        'Store Name',
        'Region',
        'Asset Comp',
        'Cabinet Type',
        'Serial Number',
        'Description Of Work Done',
        'Stock Used',
        'Stock Item Qty',
        'Invoice Store/Warrantee/Claim/No Charge/Re-Call',
        'Invoice/Cost Amount',
        'Gas Type',
        'Gas Qty',
        'Customer Rating',
        'Labour Hrs Nt',
        'Labour Hrs Ot1',
        'Labour Hrs Ot2',
        'Travel Time NT',
        'Travel Time OT1',
        'Travel Time OT2',
      ],
      dataProcess: (entry) => {
        let x = entry;
        if (typeof x.date_logged !== 'undefined' && x.date_logged !== null) {
          x.date_logged = convertDate(entry.date_logged, 0, 10);
        }
        if (
          typeof x.date_completed !== 'undefined' &&
          x.date_completed !== null
        ) {
          x.date_completed = convertDate(entry.date_completed, 0, 10);
        }

        return x;
      },
    },
    {
      name: 'payroll_report_util',
      endpoint: null,
      filename: 'payroll_utilisation',
      fields: [
        'labour_hours',
        'travel_hours',
        'total_allocated',
        'total_work_hours',
        'utilisation_rate',
      ],
      headernames: [
        'Labour Hours',
        'Travel Hours',
        'Total Allocated',
        'Total Work Hours',
        'Utilisation Rate',
      ],
    },
    {
      name: 'install_analysis_report',
      endpoint: null,
      filename: 'install_analysis_report',
      fields: [
        'ticket_number',
        'ticket_type',
        'description',
        'store_name',
        'tech_assigned_name',
        'date_completed',
        'labour_cost_actual',
        'labour_cost_budget',
        'travel_time_cost_actual',
        'travel_time_cost_budget',
        'travel_km_cost_actual',
        'travel_km_cost_budget',
        'acc_and_snt_actual',
        'acc_and_snt_budget',
        'forc_and_crane_actual',
        'forc_and_crane_budget',
        'tool_hire_actual',
        'tool_hire_budget',
        'casual_wages_actual',
        'casual_wages_budget',
        'trailer_hire_actual',
        'trailer_hire_budget',
        'other_actual',
        'other_budget',
        'transport_actual',
        'transport_budget',
        'total_actual',
        'total_budget',
        'total_variance_percentage',
      ],
      headernames: [
        'Ticket Number',
        'Ticket Type',
        'Description',
        'Store Name',
        'Technician',
        'Date Completed',
        'Labour Cost - Actual',
        'Labour Cost - Budget',
        'Travel Time Cost - Actual',
        'Travel Time Cost - Budget',
        'Travel KM - Actual',
        'Travel KM - Budget',
        'ACC and SNT - Actual',
        'ACC and SNT - Budget',
        'Forklift and Crane Hire - Actual',
        'Forklift and Crane Hire - Budget',
        'Tool Hire - Actual',
        'Tool Hire - Budget',
        'Casual Wages - Actual',
        'Casual Wages - Budget',
        'Trailer Hire - Actual',
        'Trailer Hire - Budget',
        'Other - Actual',
        'Other - Budget',
        'Transport - Actual',
        'Transport - Budget',
        'Total - Actual',
        'Total - Budget',
        'Total Variance',
      ],
    },
    {
      name: 'spare_usage_report',
      endpoint: null,
      filename: 'spare_usage_report',
      fields: [
        'ticket_number',
        'store_name',
        'stock_code',
        'stock_description',
        'stock_qty',
      ],
      headernames: [
        'Ticket Number',
        'Store Name',
        'Stock Code',
        'Stock Description',
        'Quantity',
      ],
    },
    {
      name: 'ticketing_total_tickets',
      endpoint: null,
      filename: 'ticketing_total_tickets',
      fields: ['repair', 'upliftment', 'install', 'total'],
      headernames: ['Repairs', 'Upliftments', 'Installations', 'Total'],
    },
    {
      name: 'ticketing_dashboard_status',
      endpoint: null,
      filename: 'ticketing_dashboard_status',
      fields: ['statusName', 'count'],
      headernames: ['Status', 'Ticket Qty'],
    },
    {
      name: 'ticketing_tickets_per_region',
      endpoint: null,
      filename: 'ticketing_tickets_per_region',
      fields: [
        'region_name',
        'technician',
        'subbie',
        'upliftment',
        'install',
        'total',
      ],
      headernames: [
        'Region',
        'Technicians',
        'Sub Contractors',
        'Upliftments',
        'Installations',
        'Total',
      ],
    },
    {
      name: 'ticketing_tickets_per_category',
      endpoint: null,
      filename: 'ticketing_tickets_per_category',
      fields: ['category_name', 'repair', 'upliftment', 'install', 'total'],
      headernames: [
        'Category',
        'Repairs',
        'Upliftments',
        'Installations',
        'Total',
      ],
    },
    {
      name: 'ticketing_response_time_per_tech_type',
      endpoint: null,
      filename: 'ticketing_response_time_per_tech_type',
      fields: ['period', 'technicians', 'sub_contractors', 'total'],
      headernames: ['Period', 'Technicians', 'SubContractors', 'Total'],
    },
    {
      name: 'ticketing_tickets_per_tech',
      endpoint: null,
      filename: 'ticketing_tickets_per_tech',
      fields: [
        'tech_name',
        'total_tickets',
        'install_tickets',
        'repair_tickets',
        'avg_rating',
      ],
      headernames: [
        'Tech',
        'Total Tickets',
        'Installation Tickets',
        'Repair Tickets',
        'Average Rating',
      ],
    },
    {
      name: 'ticketing_customer_feedback',
      endpoint: null,
      filename: 'ticketing_customer_feedback',
      fields: ['description', 'count', 'average_percentage'],
      headernames: ['Description', 'Total', 'Average'],
    },
    {
      name: 'ticketing_invoice_type_for_repair_tickets',
      endpoint: null,
      filename: 'ticketing_invoice_type_for_repair_tickets',
      fields: [
        'description',
        'count',
        'labour_hrs',
        'travel_time',
        'travel_km',
        'total_amt',
        'average_percentage',
      ],
      headernames: [
        'Invoice Type',
        'Ticket Qty',
        'Labour Hrs',
        'Travel Time',
        'Travel KM',
        'Total Time',
        'Average',
      ],
    },
    {
      name: 'ticketing_tickets_per_cabinet_type_for_repair_tickets',
      endpoint: null,
      filename: 'ticketing_tickets_per_cabinet_type_for_repair_tickets',
      fields: ['cabinet_type', 'count'],
      headernames: ['Cabinet Type', 'Repair Tickets'],
    },
    {
      name: 'ticketing_tickets_per_invoice_for_repair_tickets',
      endpoint: null,
      filename: 'ticketing_tickets_per_invoice_for_repair_tickets',
      fields: [
        'name',
        'invoice',
        'no_charge',
        'claim_supplier',
        'recall',
        'warranty',
      ],
      headernames: [
        'Cabinet',
        'Invoice Store',
        'No Charge',
        'Claim Supplier',
        'Re-Call',
        'Warrantee',
      ],
    },
    {
      name: 'ticketing_repair_tickets_response_time_per_region',
      endpoint: null,
      filename: 'ticketing_repair_tickets_response_time_per_region',
      fields: [],
      headernames: [],
    },
    {
      name: 'Time_Attendance_Clocked_Times',
      endpoint: '/r2_timelines',
      filename: 'Time_Attendance_Clocked_Times',
      fields: [
        'tech_username',
        'tech_name',
        'tech_surname',
        'entry_type',
        'ticket_id',
        'start_time',
        'stop_time',
        'start_time_override',
        'stop_time_override',
      ],
      headernames: [
        'User',
        'Name & Surname',
        'Department',
        'Type',
        'Ticket Number',
        'Start Time',
        'End Time',
        'Start Time Override',
        'End Time Override',
      ],
      dataProcess: (entry) => {
        let x = entry;
        if (typeof x.start_time !== 'undefined' && x.start_time !== null) {
          x.start_time = convertDate(entry.start_time, 0, 10);
        }
        if (typeof x.stop_time !== 'undefined' && x.stop_time !== null) {
          x.stop_time = convertDate(entry.stop_time, 0, 10);
        }
        if (
          typeof x.start_time_override !== 'undefined' &&
          x.start_time_override !== null
        ) {
          x.start_time_override = convertDate(entry.start_time_override, 0, 10);
        }
        if (
          typeof x.stop_time_override !== 'undefined' &&
          x.stop_time_override !== null
        ) {
          x.stop_time_override = convertDate(entry.stop_time_override, 0, 10);
        }

        return x;
      },
    },

    {
      name: 'serial_list',
      endpoint: '/r2_serial_numbers',
      filename: 'Serial_List',
      fields: [
        'serial_number',
        'cabinet_name',
        'store_category_name',
        'store_name',
        'store_region_name',
        'install_date',
        'warranty_period',
        'age',
        'in_warranty',
      ],
      headernames: [
        'Serial Number',
        'Cabinet Type',
        'Store Category',
        'Customer Name',
        'Region',
        'Installation Date',
        'Warrantee Period (Years)',
        'Age (Years)',
        'Warrantee Status',
      ],
      dataProcess: (entry) => {
        let x = entry;
        if (typeof x['install_date'] === 'string') {
          let parsedDate = new Date(x['install_date']);
          let currentDate = new Date();

          let EpochDiff = currentDate.getTime() - parsedDate.getTime();

          let yearDiff = 0;
          if (EpochDiff > 0) {
            yearDiff =
              Math.round(
                (EpochDiff / (1000 * 60 * 60 * 24 * 365.2425) +
                  Number.EPSILON) *
                  100
              ) / 100;

            let warrantyPeriod = x['warranty_period'] ?? 0;
            //Set extra fields
            x.age = String(yearDiff);
            x.in_warranty =
              warrantyPeriod > yearDiff ? 'In Warrantee' : 'Out Of Warrantee';
          }
        }
        return x;
      },
    },
  ];

  maxRowsPerPage = 1000;

  constructor(schemaName, filterOptions = null, enqNotification = false) {
    this.rawData = 'data:text/csv;charset=utf-8,';
    this.isValid = false;
    this.activeSchema = false;
    this.totalRows = 0;
    this.showNotificationFunction = enqNotification;
    this.filterOptions = {
      pagereq: filterOptions ?? {},
    };

    if (typeof schemaName === 'string') {
      this.activeSchema = this.findSchema(schemaName);

      if (this.activeSchema !== false) {
        this.isValid = true;
      } else {
        console.log(`Failed to find schema for ${schemaName}`);
      }

      if (
        typeof this.activeSchema?.headernames === 'object' &&
        this.activeSchema.headernames.length > 0
      ) {
        if (this.activeSchema.headernames.length > 0) {
          //Add header info
          this.rawData += '"';
          this.rawData += this.activeSchema.headernames.join('","');
          this.rawData += '"\r\n';
        }
      }
    }
  }

  //Type: success, warning, error
  showNotification(message, type) {
    if (this.showNotificationFunction !== false && this.isValid === true) {
      this.showNotification(message, type);
    }
  }

  appendToDataString(appendData) {
    if (this.isValid) {
      this.rawData += appendData;
    }
  }

  buildDataStringFromEntry(entry) {
    let tempString = false;

    if (this.isValid) {
      tempString = '';
      for (let i = 0; i < this.activeSchema.fields.length; i++) {
        tempString +=
          '"' + this.formatField(entry[this.activeSchema.fields[i]]) + '"';
        if (i !== this.activeSchema.fields.length - 1) {
          tempString += ',';
        }
      }
      tempString += '\r\n';
    }
    return tempString;
  }

  formatField(string) {
    if (typeof string === 'string') {
      return string.replace('"', '""').replace('#', '%23');
    } else if (typeof string === 'number') {
      return string.toString();
    } else return '';
  }

  async populateData(page = 0) {
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = this.filterOptions;

    body.pagereq['page'] = page;
    body.pagereq['rowsperpage'] = this.maxRowsPerPage;

    let request = new Request(`${APIROOT}/api${this.activeSchema.endpoint}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });

    let result = {
      success: false,
      totalrows: 0,
      rows: [],
    };

    await fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to retrieve information`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (
          parsed.success === true &&
          typeof parsed?.data?.value === 'object'
        ) {
          result.success = true;
          result.totalrows = parsed.data.totalrows;
          result.rows = parsed.data.value;
        } else {
          throw new Error(`Failed to parse data`);
        }
      })
      .catch((error) => {
        this.showNotification(
          typeof error == 'string' ? error : 'Hook Connection Error',
          'error'
        );
      });
    return result;
  }

  async Download() {
    if (this.isValid && this.activeSchema.endpoint !== null) {
      let result = await this.populateData(0);

      if (result.success === true) {
        for (let i = 1; i * this.maxRowsPerPage <= result.totalrows; i++) {
          let next = await this.populateData(i);

          if (next.success === true) {
            result.rows = result.rows.concat(next.rows);
          } else {
            console.log(`Failed to fetch next set`, next);
            break;
          }
        }
      } else {
        console.log(`Failed to retrieve list`, result);
      }

      for (let i = 0; i < result.rows.length; i++) {
        let alteredData =
          typeof this.activeSchema?.dataProcess === 'function'
            ? this.activeSchema?.dataProcess(result.rows[i])
            : result.rows[i];
        this.appendToDataString(this.buildDataStringFromEntry(alteredData));
      }

      this.printDataString();
    }
  }

  ExportRawData(data) {
    let Data = JSON.parse(JSON.stringify(data));

    if (this.isValid) {
      if (typeof Data === 'object') {
        for (let i = 0; i < Data.length; i++) {
          let alteredData =
            typeof this.activeSchema?.dataProcess === 'function'
              ? this.activeSchema?.dataProcess(Data[i])
              : Data[i];
          this.appendToDataString(this.buildDataStringFromEntry(alteredData));
        }
        this.printDataString();
      }
    }
  }

  OverrideHeaders(headerNames = null, HeaderFields = null) {
    if (this.isValid) {
      if (headerNames !== null) {
        this.activeSchema.headernames = headerNames;
        this.rawData += '"';
        this.rawData += this.activeSchema.headernames.join('","');
        this.rawData += '"\r\n';
      }
      if (HeaderFields !== null) {
        this.activeSchema.fields = HeaderFields;
      }
    }

    console.log(`Active schema`);
    console.log(this.activeSchema);
    return this;
  }

  printDataString() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();

    let fileName = this.activeSchema?.filename ?? 'data';

    today = yyyy + '_' + mm + '_' + dd;

    let encodedURI = encodeURI(this.rawData);
    let link = document.createElement('a');
    link.setAttribute('href', encodedURI);
    link.setAttribute('download', today + '_' + fileName + '.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  //Find schema from list
  findSchema(schemaName) {
    let returnThis = false;
    for (let i = 0; i < this.schemas.length; i++) {
      if (this.schemas[i].name === schemaName) {
        returnThis = this.schemas[i];

        return returnThis;
      }
    }
    return false;
  }
}

export default ExportToCsv;
